<template>
  <ModalComponent
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="38"
    :style-class-contain="styleClassContain"
  >
    <ModalHeader
      v-if="header"
      :title="getUiText(headerTitle)"
      :class="'tw-px-[20px] sm:tw-px-[40px]'"
      @close="handleCloseModal"
    />
    <div
      v-if="!header"
      class="tw-text-right tw-pt-[20px] tw-pr-[20px] tw-pl-[40px] tw-leading-[12px]"
    >
      <a href="#" @click="handleCloseModal">
        <img class="tw-w-3 tw-h-3" src="@/assets/img/close.svg" alt="close" />
      </a>
    </div>
    <div
      :class="`tw-px-[20px] tw-pb-[40px] sm:tw-px-[40px] ${
        header ? 'tw-pt-[20px] sm:tw-pt-[40px]' : 'tw-pt-[8px]'
      }`"
    >
      <div
        :class="`tw-text-[25px] tw-text-[#211F58] tw-font-[Poppins] tw-font-[600] tw-mb-[15px] ${
          header ? 'tw-leading-[100%]' : 'tw-leading-normal'
        }`"
      >
        {{
          containTitle.length === 1
            ? containTitle.toString()
            : containTitle.join(", ")
        }}
      </div>
      <div
        class="tw-text-[15px] tw-text-[#231F20] tw-font-[400] tw-leading-[145%]"
      >
        {{ getUiText(containSubTitle)
        }}<span v-if="header" class="tw-font-[500] tw-pl-[2px]"
          >&nbsp;{{
            getUiText(
              "app-settings-team-members-profile-modal-delete-action-helper-b-1",
            )
          }}</span
        >
      </div>
    </div>
    <div
      class="button-container-bottom tw-flex tw-justify-between tw-px-[20px] tw-pb-[20px] sm:tw-px-[40px] sm:tw-pb-[40px]"
    >
      <Button2
        :title="getUiText('app-settings-domain-delete-modal-action-cancel-1')"
        :class="'tw-text-[15px] tw-leading-[100%] tw-pl-[18px] tw-pr-[18px] tw-py-[12px] tw-rounded-[27px]'"
        @click="handleCloseModal"
      />
      <Button1
        v-if="!isLoadingDelete"
        :title="getUiText(actionTitle)"
        :class="`tw-ml-[15px] tw-text-[15px] tw-leading-[100%] !tw-px-[18px] !tw-py-[14px] tw-rounded-[27px] ${
          redBtn
            ? '!tw-bg-[#F7553C] hover:!tw-bg-[#c82333]'
            : 'hover:!tw-bg-[#0056b3]'
        } `"
        :disabled="false"
        data-cy="delete-domain-modal-delete-button"
        @click="handleActionclick"
      />
      <div
        v-else
        :class="`tw-relatve tw-text-[15px] tw-leading-[100%] tw-ml-[15px] tw-flex tw-justify-center tw-items-center tw-h-[43px] !tw-px-[18px] !tw-py-[14px] tw-rounded-[27px]  ${
          redBtn
            ? '!tw-bg-[#F7553C] hover:!tw-bg-[#c82333]'
            : 'hover:!tw-bg-[#0056b3]'
        } button`"
      >
        <span :class="`tw-text-transparent`">{{ getUiText(actionTitle) }}</span>
        <div
          class="tw-absolute tw-top-[-1] tw-flex tw-justify-center tw-items-center tw-h-[39px] tw-w-[39px]"
        >
          <!-- eslint-disable vue/no-unused-refs -->
          <LottieAnimation
            ref="anim"
            :animation-data="ProgressAnimation"
            :auto-play="true"
            :loop="true"
          />
        </div>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import store from "../../store";
import utilities from "../../utils/utilities";
import { PropType, computed, ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import ModalHeader from "../common/modalHeader.vue";
import Button2 from "../common/button2.vue";
import Button1 from "../common/button1.vue";
const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  header: {
    type: Boolean,
    required: false,
  },
  redBtn: {
    type: Boolean,
    required: false,
  },
  headerTitle: {
    type: String,
    required: false,
    default: "Header Title",
  },
  containTitle: {
    type: Array as PropType<string[]>,
    required: true,
  },
  containSubTitle: {
    type: String,
    required: true,
  },
  actionTitle: {
    type: String,
    required: true,
  },
  isLoadingDelete: {
    type: Boolean,
    required: false,
  },
});
const emit = defineEmits(["update:show", "update:actionHandle"]);

const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};

let showRef = ref(props.show);
let newDomainValue = ref("");

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (props.show === true) newDomainValue.value = "";
  },
);

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleActionclick = () => {
  // showRef.value = false;
  emit("update:actionHandle", showRef.value);
};
</script>

<style scoped lang="scss">
.icon-input-clear {
  position: absolute;
  right: 67px;
  height: 65px;
}

.modal-add-domain input::placeholder {
  font-size: 15px !important;
}

.button-add-domain {
  background-color: #387dff;
  border-color: #387dff;
}

@media (max-width: 991px) {
  .icon-input-clear {
    right: 65px !important;
  }
}

.profileModal-header {
  border-bottom: 1px solid #eaebef;
}
</style>
